<div class="modal-content">
  <div class="modal-header">
    <span>Edit Image</span>
    <i class="material-icons" data-bs-dismiss="modal" (click)="closeModal()"
      >close</i
      >
    </div>
    @if (uploadImageForm) {
      <div class="modal-body">
        <form [formGroup]="uploadImageForm">
          <div
            class="image-upload-box image-upload-box-large"
            id="editImageUploadComponentId"
            >
            <div class="image-container">
              <input
                class="uploadResource placeholder-cover btn btn-primary"
            style="
              opacity: 0;
              position: absolute;
              z-index: 999;
              height: 100%;
              width: 100%;
            "
                id="file-in allbutton-style"
                type="file"
                #fileInputImage
                (click)="clearImageOnClick()"
                value=""
                (change)="fileChangeEvent($event, imageAllowedExtensions)"
                accept="image/jpeg,image/png,image/jpg, image/gif"
                />
              <label for="file-in">
                @if (responseImageData?.assetId == null) {
                  <img
                    src="/assets/img/image-placeholder.png"
                    alt="Image Here"
                    />
                }
                @if (responseImageData?.assetId != null) {
                  <img
              src="{{
                '/api/Assets/Image/' +
                  responseImageData?.assetId +
                  '?height=300&ratio=' +
                  setup.device_pixel_ratio
                  | loadSecureAssets : true
                  | async
              }}"
                    class="container-preview-image"
                    alt=""
                    onerror="this.src = 'assets/img/loader.gif'"
                    (load)="imageLoaded = true"
                    [hidden]="!imageLoaded"
                    />
                }
              </label>
            </div>
          </div>
          @if (progressbarDisplay.image == true) {
            <div
              class="progress progress-style"
              >
              <div
                class="progress-bar"
                role="progressbar"
                aria-valuenow="0"
                aria-valuemin="0"
                aria-valuemax="100"
                [style.width]="dynamicProgressbar.image + '%'"
                >
                {{ dynamicProgressbar.image }}%
              </div>
            </div>
          }
          <div>
            <p
              style="text-align: center; margin-top: 15px"
              id="uploadedMainImageId"
              >
              {{ responseImageData?.asset?.name || "Upload JPEG, PNG or GIF" }}
            </p>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-7">
                <label class="custom-checkbox custom__checkmark top-spacer-2">
                  <input
                    id="cbx1021"
                    class="checkbox"
                    [attr.disabled]="disableEnlargeImage ? '' : null"
                    type="checkbox"
                    formControlName="enlargeImage"
                    />
                  <span class="checkmark checkbox"></span>
                </label>
                <label
                  for="cbx1021 control-label "
                  style="color: grey; font-weight: 700"
                  >Enlarge Image</label
                  >
                </div>
              </div>
            </div>
            <ul class="nav nav-pills playbook-tabs top-spacer-20">
              <li class="img-txt-msg mrr15">Image Action (on click)</li>
              <li
                [ngClass]="activePill ? 'active pointer' : 'pointer'"
                (click)="activePill = true"
                >
                <a data-bs-toggle="pill" data-bs-target="#link">Link</a>
              </li>
              <li
                [ngClass]="!activePill ? 'active pointer' : 'pointer'"
                (click)="activePill = false"
                >
                <a data-bs-toggle="pill" data-bs-target="#slideshow">Slideshow</a>
              </li>
            </ul>
            <hr style="margin-top: 0; border-color: #428bca" />
            <div class="tab-content">
              @if (activePill) {
                <div id="link">
                  <div class="form-group">
                    <div class="row align-items-center">
                      <label for="LinkURL" class="control-label col-sm-4"
                        >Link URL</label
                        >
                        <div class="col-sm-8">
                          <input
                            type="text"
                            formControlName="linkUrl"
                            id="ImageLink"
                            name="ImageLink"
                            class="textbox inline full"
                            [ngClass]="{ error: dataSubmitted && form.linkUrl.errors }"
                            />
                          @if (dataSubmitted && form.linkUrl.errors) {
                            <div
                              class="text-danger"
                              >
                              @if (form.linkUrl.errors.pattern) {
                                <div>
                                  Please enter the valid url
                                </div>
                              }
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                }
                @if (!activePill) {
                  <div id="slideshow">
                    @if (errorMessage) {
                      <p class="text-danger">
                        {{ errorMessage }}
                      </p>
                    }
                    <div class="row">
                      <div class="col-md-12 form-group">
                        <div class="row align-items-center">
                          <label class="control-label col-sm-4" for="slideshow"
                            >Slideshow Settings</label
                            >
                          </div>
                        </div>
                        <div class="col-md-12 form-group">
                          <div class="row align-items-center">
                            <label
                              for="type"
                              class="control-label col-sm-4"
                              id="groupLabelId"
                              >Group</label
                              >
                              @if (!isGroupEditable) {
                                <div
                                  class="col-sm-6 inline-label-wrapper"
                                  >
                                  <ng-select
                                    class="custom"
                                    [items]="people3$ | async"
                                    bindLabel="name"
                                    [addTag]="!languageId || languageId == 1"
                                    [multiple]="false"
                                    [hideSelected]="true"
                                    [loading]="people3Loading"
                                    formControlName="agree"
                                    [typeahead]="people3input$"
                                    (change)="another($event)"
                                    [clearable]="false"
                                    >
                                  </ng-select>
                                </div>
                              }
                              @if (isGroupEditable) {
                                <div
                                  class="col-sm-6 inline-label-wrapper"
                                  >
                                  <div class="input-group">
                                    <ng-container [formGroup]="editImageGroupForm">
                                      <input
                                        manage-image-group
                                        class="form-control"
                                        placeholder="Group Name"
                                        formControlName="editImageGroupName"
                                        (keyup.enter)="updateImageGroup()"
                                        />
                                      <span class="input-group-btn">
                                        <button
                                          class="btn btn-default"
                                          type="button"
                                          (click)="cancleGroupUpdate()"
                          style="
                            height: 34px;
                            background: #ececec;
                            border-color: #ccc;
                          "
                                          >
                                          Cancel
                                        </button>
                                      </span>
                                    </ng-container>
                                  </div>
                                </div>
                              }
                              @if (
                                !isGroupEditable &&
                                selectedImageGroup != null &&
                                (languageId == null || languageId == 1)
                                ) {
                                <div
                                  class="col-sm-2"
                                  >
                                  <i
                                    class="material-icons pointer"
                                    (click)="setEditableGroupName()"
                                    >create</i
                                    >
                                    @if (
                                      selectedImageGroup.name && !selectedImageGroup.isDefault
                                      ) {
                                      <i
                                        class="material-icons pointer"
                                        (click)="deleteImageGroup(selectedImageGroup)"
                                        >delete</i
                                        >
                                      }
                                    </div>
                                  }
                                </div>
                              </div>
                              <div class="form-group">
                                <div class="row align-items-center">
                                  <div class="offset-sm-4 col-sm-8">
                                    @if (
                                      isGroupEditable &&
                                      submitted &&
                                      editImageGroupFormControl.editImageGroupName.errors
                                      ) {
                                      <div
                                        class="col-md-12 inline-label-wrapper text-danger"
                                        >
                                        @if (
                                          editImageGroupFormControl.editImageGroupName.errors
                                          .required
                                          ) {
                                          <small
                                            >Image group name is required</small
                                            >
                                          }
                                          @if (
                                            editImageGroupFormControl.editImageGroupName.errors
                                            .maxlength
                                            ) {
                                            <small
                                              >Image group name must be less than 200 characters</small
                                              >
                                            }
                                          </div>
                                        }
                                      </div>
                                    </div>
                                  </div>
                                  @if (selectedImageGroup != null) {
                                    <div
                                      class="ng-modal modal-overlay ng-scope col-md-12"
                                      style="background-color: #fff"
                                      >
                                      <div class="image-upload-container medium" style="top: 140px">
                                        <input
                                          type="file"
                                          ng2FileSelect
                                          #fileInput
                                          (click)="clearSlideShowImages()"
                                          value=""
                                          [uploader]="uploader"
                                          multiple
                                          class="uploadResource btn"
                                          id="multifile-in"
                                          (change)="onFileChange()"
                                          />
                                        <label for="multifile-in">
                                          <div
                                            ng2FileDrop
                                            [ngClass]="{ 'nv-file-over': hasBaseDropZoneOver }"
                                            class="col-md-12 text-center imageupload well my-drop-zone"
                                            id="uploadQ"
                                            [uploader]="uploader"
                                            (fileOver)="fileOverBase($event)"
                    style="
                      background-color: #fff !important;
                      border-radius: 0px;
                      border: 3px dashed #ccc;
                      overflow-y: auto;
                      overflow-x: hidden;
                      padding: 3px 20px 10px 20px;
                    "
                                            >
                                            @if (uploader.queue.length == 0) {
                                              <p
                                                class="drop-message-file"
                                                >
                                                drop slideshow images here or click to browse
                                              </p>
                                            }
                                            @for (item of uploader.queue; track item) {
                                              <div class="col-12 no-padding">
                                                @if (item) {
                                                  <div
                                                    class="uploadifive-queue-item progress-bar-style"
                                                    id="uploadifive-uploadCAssets-file-2"
                          [ngClass]="
                            item?.progress == 100
                              ? 'padding-bottom-15'
                              : 'padding-bottom-5'
                          "
                                                    >
                                                    <a class="delete-asset" (click)="item.remove()">X</a>
                                                    <div>
                                                      <span class="filename">
                                                        {{ item?.file?.name }}
                                                      </span>
                                                      <span class="fileinfo">
                                                        @if (item?.progress != 100) {
                                                          {{ item?.progress }}%
                                                        }
                                                        @if (item?.progress == 100) {
                                                          Completed
                                                        }
                                                      </span>
                                                    </div>
                                                    @if (item && item.progress !== 100) {
                                                      <div
                                                        class="progress"
                                                        >
                                                        <div
                                                          class="progress-bar"
                              [style.width.%]="
                                item?.progress ? item.progress : '0'
                              "
                                                        ></div>
                                                      </div>
                                                    }
                                                  </div>
                                                }
                                              </div>
                                            }
                                          </div>
                                        </label>
                                      </div>
                                    </div>
                                  }
                                </div>
                                <div class="col-md-12" style="padding: 0px">
                                  <section class="dark clipboard">
                                    <div droppable-clipboard>
                                      @if (imageGroupDetail && imageGroupDetail?.length) {
                                        <ul
                                          class="clipboard-list"
                                          style="width: 572px"
                                          >
                                          @for (imageGroup of imageGroupDetail; track imageGroup) {
                                            <li
                                              style="list-style: none"
                                              id="clip-{{ imageGroup }}"
                                              fadein
                                              class="img-preview"
                                              >
                                              <span id="uniqeId" class="order-number">{{
                                                imageGroup.order + 1
                                              }}</span>
                                              <a
                                                id="deleteClipboardIconId"
                                                class="delete-clipboard-item01"
                                                (click)="deleteUploadedImage(imageGroup)"
                                                >
                                                <i class="fas fa-trash" style="color: #7f7f7f"></i>
                                              </a>
                                              <div class="clipboard-item-back01">
                                                <div
                                                  class="clipboard-item"
                                                  id="clip-item-{{ imageGroup.id }}"
                                                  >
                                                  <span class="clip-overlay"></span>
                                                  <span>
                                                    <span>
                                                      <span class="clipboard-content">
                                                        <img
                                                          class="clipped-image"
                                src="{{
                                  '/api/Assets/Image/' +
                                    imageGroup?.assetId +
                                    '?width=100'
                                    | loadSecureAssets : true
                                    | async
                                }}"
                                                          alt=""
                                                          style="width: 100px; max-height: 60px"
                                                          (load)="imageGroup.imageLoaded = true"
                                [hidden]="
                                  imageGroup.imageLoaded == null ||
                                  imageGroup.imageLoaded == false
                                "
                                                          />
                                                        @if (
                                                          imageGroup.imageLoaded == '' ||
                                                          imageGroup.imageLoaded == null ||
                                                          imageGroup.imageLoaded == false
                                                          ) {
                                                          <div
                                                            style="width: 100px; max-height: 60px"
                                                            class="ng-hide"
                                                            >
                                                            <img src="/assets/img/loader.gif" alt="" />
                                                          </div>
                                                        }
                                                      </span>
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </li>
                                          }
                                        </ul>
                                      }
                                    </div>
                                  </section>
                                </div>
                              </div>
                            }
                          </div>
                        </form>
                      </div>
                    }
                    <div class="modal-footer">
                      <button
                        class="btn vPlaybookDefaultButton btn__btn-default"
                        (click)="closeModal()"
                        >
                        Cancel
                      </button>
                      <button class="btn btn__btn-default btn__orange" (click)="save()">
                        Save
                      </button>
                    </div>
                  </div>
